import React from "react";
import { ITkQRCodeProps } from "../../../type/componentsType/TkQRCode";
import { Box } from "@mui/material";
import QRCode from 'qrcode.react';
import "./_style.scss";

/**
 * TkQRCodeコンポーネント
 * @param {ITkQRCodeProps} props - コンポーネントのプロパティ
 * @param {string} props.QRLink - QRコードのリンク
 */
const TkQRCode: React.FC<ITkQRCodeProps> = (props) => {
  const { QRLink } = props;

  return (
    <Box className="tkQrCode">
      <QRCode value={QRLink} size={150} />
    </Box>
  );
};

export default TkQRCode;
